import { api } from "@/lib/api";

import { tr } from "@/lib/i18n";
const toPng = (blob) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(blob);
  const img = new Image();
  img.onload = () => {
    const k = Math.min(1, 900 / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    resolve({ data: c.toDataURL("image/png"), w: c.width, h: c.height });
  };
  img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
  img.src = url;
});

// dati dell'azienda proprietaria del progetto per intestazione e piè di pagina del PDF
export async function loadBranding(pid) {
  const { data } = await api.get(`/projects/${pid}/branding`);
  let logo = null;
  if (data.has_logo) {
    try { logo = await toPng((await api.get(`/projects/${pid}/branding/logo`, { responseType: "blob" })).data); } catch { logo = null; }
  }
  return { ...data, logo };
}

export const APP_NAME = "Synvora Design";

export const loadAppMark = () => fetch("/synvora-logo-dark.png").then((r) => r.blob()).then(toPng).catch(() => null);

export const footerLine = (name, pr = {}) => [
  pr.legal_name || name,
  pr.address, [pr.zip, pr.city].filter(Boolean).join(" "), pr.country,
  pr.phone && `Tel. ${pr.phone}`, pr.email, pr.website, pr.vat && tr("IVA/IDI {0}", [pr.vat]),
].filter(Boolean).join(" · ");
